import React from "react";
import { Button} from "react-bootstrap"

const Resume = ({}) => {
  return (
    <div>
      <Button variant="outline-info" href="https://drive.google.com/file/d/1Uyg791jScE_UFJDPiN06yqkqJds7CaxB/view?usp=sharing"  target="_blank">My Resume</Button>{" "}
    </div>
  );
};
export default Resume;
